riot.tag2('gb-product-image', '<a class="gb-product-image {_style}" href="{_scope.link()}"> <img class="{thumbnail: opts.thumbnail !== undefined}" riot-src="{imageLink()}" alt=""> </a>', 'gb-product-image .gb-product-image.gb-stylish img,[riot-tag="gb-product-image"] .gb-product-image.gb-stylish img,[data-is="gb-product-image"] .gb-product-image.gb-stylish img{ width: 380px; } gb-product-image .gb-product-image.gb-stylish img.thumbnail,[riot-tag="gb-product-image"] .gb-product-image.gb-stylish img.thumbnail,[data-is="gb-product-image"] .gb-product-image.gb-stylish img.thumbnail{ width: 80px; }', '', function(opts) {
    this._scopeTo('gb-product');
    const _scope = this._scope;
    this.imageLink = () => _scope.image(_scope.productMeta().image);
});



/** WEBPACK FOOTER **
 ** ./src/tags/product/gb-product-image.tag.html
 **/